import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DarkModeService } from '../dark-mode.service';
import * as lit from '../shared/movano-literals';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MovanoService } from 'src/app/movano.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent {

  protected LITERALS = lit;
  protected darkMode: boolean = false;
  private darkModeSub: Subscription = new Subscription();
  protected menuDisplay: boolean = false;
  protected userDisplay: boolean = false;
  protected selectedTab: string = 'insight-application';
  protected selectedValue: string = '';

  constructor(
    private router: Router,
     private route: ActivatedRoute,
    protected movanoService: MovanoService,
    private darkModeSvc: DarkModeService) {
    this.darkModeSub = this.darkModeSvc.getVariable().subscribe((val: any) => {
      this.darkMode = val;
    });
  }

  ngOnInit() {
    // Listen to route changes
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd)
    ).subscribe(() => {
      const tab = this.route.firstChild?.snapshot.url[0]?.path || 'insight-application';
      this.movanoService.changeTab(tab);
    });

    // Subscribe to the current tab
    this.movanoService.currentTab.subscribe(tab => {
      this.selectedTab = tab;
    });

    // Initialize the selected tab based on the current route
    const initialTab = this.route.firstChild?.snapshot.url[0]?.path || 'insight-application';
    this.movanoService.changeTab(initialTab);
  }

  selectTab(tab: string) {
    let formattedTab = tab.toLowerCase();
    if(formattedTab === 'user activity') formattedTab = 'activity';
    if(formattedTab === 'health metrics') formattedTab = 'health-metrics';

    this.movanoService.changeTab(formattedTab);
    this.router.navigate([`/stats/${formattedTab}`]);
  }


  changeTheme() {
    this.darkModeSvc.setVariable(!this.darkMode);
  }

  handleInfo(value: string) {
    this.selectedValue = value;
  }
}
